// extracted by mini-css-extract-plugin
module.exports = {"videoPart":"style_videoPart__sIxfE","desc":"style_desc__2Nett"};